export const MAPS_API_KEY = "AIzaSyC5bu4tbaM6x2u-4Bggg9GfRjctWtzNYaI";